import React from 'react';
import PropTypes from 'prop-types';

// Icon
const GlutenFreeIcon = ({ className, width, height, fill, opacity }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g>
      <path
        className="icon"
        fill={fill}
        opacity={opacity}
        d="M11.3072 16.3257C10.7158 16.9153 10.0861 17.3437 9.41783 17.6109C8.74961 17.8703 8.03999 18 7.28898 18C6.33691 18 5.47354 17.8035 4.69888 17.4105C3.93013 17.0096 3.27077 16.4554 2.72082 15.748C2.17087 15.0327 1.7451 14.1877 1.44351 13.213C1.14784 12.2304 1 11.1575 1 9.99411C1 8.82289 1.14192 7.74994 1.42577 6.77524C1.70962 5.79268 2.11469 4.94768 2.64099 4.24024C3.1732 3.53279 3.81186 2.98256 4.55696 2.58954C5.30797 2.19651 6.14472 2 7.06723 2C7.54622 2 7.99269 2.05109 8.40663 2.15328C8.82057 2.25547 9.20495 2.39695 9.55976 2.57775C9.91457 2.75854 10.2369 2.9747 10.5266 3.22623C10.8223 3.47777 11.0884 3.75682 11.3249 4.06338L10.6597 5.45468C10.5591 5.67477 10.4231 5.81233 10.2516 5.86735C10.0861 5.91452 9.9057 5.85949 9.71055 5.70228C9.52723 5.55294 9.34392 5.41538 9.1606 5.28961C8.97728 5.15598 8.77918 5.042 8.56629 4.94768C8.35932 4.84549 8.1287 4.76689 7.87442 4.71186C7.62014 4.65684 7.32742 4.62933 6.99626 4.62933C6.4404 4.62933 5.94071 4.75903 5.4972 5.01842C5.05369 5.26996 4.67523 5.62761 4.36181 6.09138C4.0484 6.55515 3.80594 7.1211 3.63445 7.78924C3.46888 8.44952 3.38609 9.18448 3.38609 9.99411C3.38609 10.8745 3.47775 11.6605 3.66106 12.3522C3.84438 13.044 4.10162 13.6296 4.43277 14.1091C4.76984 14.5807 5.17491 14.9423 5.64799 15.1938C6.12107 15.4375 6.64737 15.5593 7.22689 15.5593C7.61718 15.5593 7.96608 15.5082 8.27358 15.406C8.58699 15.296 8.89449 15.1466 9.19608 14.958V12.2226H7.83894C7.69701 12.2226 7.5817 12.1675 7.493 12.0575C7.41021 11.9474 7.36881 11.8138 7.36881 11.6566V9.91157H11.3072V16.3257Z"
      />
      <path
        className="icon"
        fill={fill}
        opacity={opacity}
        d="M19 2.17686V4.64112H15.4141V9.07443H18.2549V11.5387H15.4141V17.8349H13.0724V2.17686H19Z"
      />
    </g>
  </svg>
);

GlutenFreeIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  opacity: PropTypes.string,
};

GlutenFreeIcon.defaultProps = {
  height: '100%',
  fill: 'currentColor',
  opacity: '1',
};

export default GlutenFreeIcon;
